/**
 * @generated SignedSource<<45cd151055de6ca7b8e6d94560037752>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RuptureSetDiagnosticContainerQuery$variables = {
  ids?: ReadonlyArray<string> | null | undefined;
};
export type RuptureSetDiagnosticContainerQuery$data = {
  readonly nodes: {
    readonly result: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
          readonly created?: any | null | undefined;
          readonly fault_models?: ReadonlyArray<string | null | undefined> | null | undefined;
          readonly file_name?: string | null | undefined;
          readonly file_size?: any | null | undefined;
          readonly file_url?: string | null | undefined;
          readonly id?: string;
          readonly md5_digest?: string | null | undefined;
          readonly meta?: ReadonlyArray<{
            readonly k: string | null | undefined;
            readonly v: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined>;
    } | null | undefined;
  } | null | undefined;
};
export type RuptureSetDiagnosticContainerQuery = {
  response: RuptureSetDiagnosticContainerQuery$data;
  variables: RuptureSetDiagnosticContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id_in",
        "variableName": "ids"
      }
    ],
    "concreteType": "NodeFilter",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SearchResultConnection",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "file_name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "file_url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "file_size",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "md5_digest",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "KeyValuePair",
                        "kind": "LinkedField",
                        "name": "meta",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "k",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "v",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "FileInterface",
                    "abstractKey": "__isFileInterface"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fault_models",
                        "storageKey": null
                      }
                    ],
                    "type": "RuptureSet",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RuptureSetDiagnosticContainerQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RuptureSetDiagnosticContainerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "93b557d3569f8e42d30d930ef248a972",
    "id": null,
    "metadata": {},
    "name": "RuptureSetDiagnosticContainerQuery",
    "operationKind": "query",
    "text": "query RuptureSetDiagnosticContainerQuery(\n  $ids: [ID!]\n) {\n  nodes(id_in: $ids) {\n    result {\n      edges {\n        node {\n          __typename\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on FileInterface {\n            __isFileInterface: __typename\n            file_name\n            file_url\n            file_size\n            md5_digest\n            meta {\n              k\n              v\n            }\n          }\n          ... on RuptureSet {\n            created\n            fault_models\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c242159091f09722865f577128a4c5b7";

export default node;
